import { render, staticRenderFns } from "./newsiteuser.vue?vue&type=template&id=3baf853c&scoped=true"
import script from "./newsiteuser.vue?vue&type=script&lang=js"
export * from "./newsiteuser.vue?vue&type=script&lang=js"
import style0 from "./newsiteuser.vue?vue&type=style&index=0&id=3baf853c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3baf853c",
  null
  
)

export default component.exports